import { render, staticRenderFns } from "./folders-payment-files.vue?vue&type=template&id=2409dfee&scoped=true"
import script from "./folders-payment-files.vue?vue&type=script&lang=js"
export * from "./folders-payment-files.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2409dfee",
  null
  
)

export default component.exports